module.exports = __webpack_public_path__ + "img/icon2.a27e69e7.png";